<template>
  <div>
    <home-header></home-header>
    <div class="content page-width">
      <personal-center></personal-center>
      <div class="margin-top-30"></div>
      <a-spin :spinning="newsSpinning">
        <news-list :arrs="arrs"></news-list>
        <div class="pagination">
          <a-pagination show-quick-jumper :default-current="1" :total="total" :current="pageNo" :pageSize="pageSize" @change="onChange" />
        </div>
      </a-spin>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import Foot from "@/common/components/Foot";
import NewsList from "./components/NewsList";
import PersonalCenter from "@/common/components/PersonalCenter";
import common from "@/common/js/common.js";
import axios from "axios";
export default {
  name: "News",
  components: {
    HomeHeader,
    Foot,
    NewsList,
    PersonalCenter,
  },
  data: function () {
    return {
      arrs: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      newsSpinning: true,
    };
  },
  created() {
    this.getDetailInfo();
    if(this.$route.name !== 'myPersonalStudyFee'&&localStorage.getItem('token')){
      this.axios.get('/sys/login/userinfo').then(res=>{
        let userInfo = res.result.userInfo
        userInfo.eduLogo = res.result.eduLogo || null
        userInfo.headTitle = res.result.headTitle
        userInfo.pageTitle = res.result.pageTitle
        document.title = `${userInfo.eduName} - ${userInfo.pageTitle}`
        this.common.setStorage('userInfo', userInfo)
        this.$store.commit('SET_USERINFO', userInfo)
      })
    }
  },
  methods: {
    getDetailInfo() {
      this.axios
        .get(
          `/biz/article/list?pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        )
        .then((res) => {
          if (res.success) {
            this.newsSpinning = false;
            this.total = res.result.total;
            this.arrs = res.result.records;
          }
        });
    },
    handleGetDataSucc(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.arrs = data.course;
      }
    },
    onChange(index) {
      this.newsSpinning = true
      this.pageNo = index;
      this.getDetailInfo();
    },
  },
  mounted() {
    // this.getDetailInfo()
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;

    .localtion {
      line-height: 30px;
      border-bottom: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.content-left {
  background: #f7f6f6;
}
</style>
<style>
.pagination {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/news/Index.vue